var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoBackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause-circle-line"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.7499 23.3096C22.3811 23.696 22.3811 24.3041 22.7499 24.6906L30.3409 32.6429C30.7098 33.0293 30.7098 33.6374 30.3409 34.0238L29.1779 35.2422C28.784 35.6549 28.1252 35.6549 27.7312 35.2422L17.6591 24.6906C17.2902 24.3041 17.2902 23.696 17.6591 23.3096L27.7312 12.7578C28.1252 12.3451 28.784 12.3451 29.1779 12.7578L30.3409 13.9762C30.7098 14.3626 30.7098 14.9707 30.3409 15.3571L22.7499 23.3096Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoBackIcon);
export default __webpack_public_path__ + "static/media/videoBackIcon.156d474b2bf55e0e379250d20344c516.svg";
export { ForwardRef as ReactComponent };